import axiosInstance from "../../api/axiosInstance";
import { createUserFailure, createUserStart, createUserSuccess, deleteUserFailure, deleteUserStart, deleteUserSuccess, getUsersFailure, getUsersStart, getUsersSuccess, updateUserFailure, updateUserStart, updateUserSuccess } from "./UserAction";

export const getUsers = async (dispatch, toast) => {
    dispatch(getUsersStart());

    try {
        const res = await axiosInstance.get(`/admin/users`);

        dispatch(getUsersSuccess(res.data.users));
        toast.success("User Fetched Successfully");

    } catch (error) {
        console.error("Failed to fetch users:", error);

        dispatch(getUsersFailure());

        toast.error(
            error?.response?.data?.message || "Failed to fetch users"
        );
    }
};

export const updateUser = async (user, dispatch, navigate, toast) => {
    dispatch(updateUserStart());

    try {
        const res = await axiosInstance.put(
            `/admin/users/${user._id}`,
            user
        );

        dispatch(updateUserSuccess(res.data));

        toast.success("User Updated Successfully");

        navigate("/");
    } catch (error) {
        console.error("Failed to update user:", error);

        dispatch(updateUserFailure());

        toast.error(
            error?.response?.data?.message || "Failed to update user"
        );
    }
};
